import { useSessionStorageState } from 'ahooks';

export function useSessionStorageBooleanState(
	key: string,
	defaultValue = false
) {
	const [value, setValue] = useSessionStorageState<boolean>(key, {
		defaultValue,
	});

	const handlers = {
		setTrue: () => setValue(true),
		setFalse: () => setValue(false),
		toggle: () => setValue((prev) => !prev),
	};

	return [value, handlers] as const;
}
